import { ROUTES } from 'Constants';
import { Location } from 'react-router-dom';

const showLightNavBarOnPage = (isMobile: boolean, location: Location) => {
	const pathname = location?.pathname.toString();

	if (!pathname) {
		return false;
	}

	// Split the pathname into segments and check if any segment matches exactly.
	// Using includes() on the full pathname can false-positive when a UUID in the
	// URL happens to contain a matching substring (e.g. a booking GUID containing "404").
	const segments = pathname.split('/').filter(Boolean);
	const matchesSegment = (path: string) => segments.some(seg => seg === path) || pathname.startsWith(path);

	const alwaysShowPaths = [
		'home',
		'booking-success',
		ROUTES.BOOKING_CANCELLED_SUCCESS.path,
		'404',
		'whoops',
		'invalid-token',
		'claim-voucher',
	];

	const isUpcomingEvents = segments.includes('upcoming-events') && !segments.includes('create');

	if (alwaysShowPaths.some(path => matchesSegment(path)) || isUpcomingEvents) {
		return true;
	}

	if (isMobile) {
		return false;
	}

	return segments.includes('booking-wizard') || segments.includes('event-booking-wizard');
};

export default showLightNavBarOnPage;
